import React from 'react';
import { PlusIcon } from '@radix-ui/react-icons';

import styles from './empty-stage-placeholder.module.scss';
interface EmptyStagePlaceholderProps {
  onClick: () => void;
}

export const EmptyStagePlaceholder: React.FC<EmptyStagePlaceholderProps> = ({ onClick }) => (
  <button className={styles['placeholder']} type="button" onClick={onClick}>
    <PlusIcon />
    <span>Create a first stage</span>
  </button>
);
